import { render } from "./pay-btns.vue?vue&type=template&id=571c82ec&scoped=true"
import script from "./pay-btns.vue?vue&type=script&lang=js"
export * from "./pay-btns.vue?vue&type=script&lang=js"

import "./pay-btns.vue?vue&type=style&index=0&id=571c82ec&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571c82ec"]])

export default __exports__